"use client"
import React, { useState, useEffect, useCallback } from "react";

import "@/components/shared/UrlInput.css";
import { Form, FormGroup } from "react-bootstrap";
import MetadataThumbnail from "@/components/shared/MetadataThumbnail";
import LoadingAnimation from "@/components/shared/LoadingAnimation";
import useApi from "@/components/api/useApi";

import debounce from "lodash.debounce";

const UrlInput = ({
  value,
  metadata,
  required,
  label,
  text,
  placeholder,
  name,
  onUrlChange,
  onBlur,
  loadMetadata = true,
  showThumbnail = true
}) => {
  const api = useApi();

  var lastTimestamp = null;

  const [loading, setLoading] = useState(false);
  const [theValue, setTheValue] = useState("");
  const [theUrl, setTheUrl] = useState(null);
  const [theMetadata, setTheMetadata] = useState(null);
  const [invalid, setInvalid] = useState(false);

  useEffect(() => {
    if (value) {
      setTheValue(value);
      setTheUrl(value);
    }
    if (metadata) {
      setTheMetadata(metadata);
    }
  }, []);

  useEffect(() => {
    if (value) {
      setTheValue(value);
      setTheUrl(value);
    }
  }, [value]);

  const isUrl = url => {
    // write a regular expression to match a url.

    var expression = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/;
    var regex = new RegExp(expression);
    return url.match(regex);
  };

  const getUrlMetadata = url => {
    setTheMetadata(null);
    setInvalid(false);
    setLoading(true);
    api
      .getUrlMetadata(url)
      .then(metadata => {
        setTheUrl(url);
        setTheMetadata(metadata);
        setLoading(false);
        onUrlChange(url, metadata);
      })
      .catch(error => {
        setLoading(false);
        // onUrlChange(url, null);
      });
  };

  const onClear = () => {
    setTheValue("");
    setTheUrl(null);
    setTheMetadata(null);
    onUrlChange(null, null);
  };

  const checkInputValue = inputValue => {
    const input = inputValue.trim();

    if (input.length > 3) {
      // console.log(input,isUrl(input));
      checkUrl(input);
    }
  };

  const checkUrl = input => {
    if (isUrl(input)) {
      if (loadMetadata) {
        if (theUrl !== input) {
          getUrlMetadata(input);
        }
      } else {
        setTheUrl(input);
        onUrlChange(input);
        setInvalid(false);
      }
    } else {
      setInvalid(true);
    }
  };

  const changeHandler = event => {
    // console.log("changeHandler", event, event.target);
    setTheValue(event.target.value);
  };

  useEffect(() => {
    if (theValue && theValue !== "" && isUrl(theValue)) {
      checkInputValue(theValue);
    }
  }, [theValue]);

  var debouncedEvent;

  // const debounceEvent = (...args) => {
  //   debouncedEvent = debounce(...args);
  //   return e => {
  //     e.persist();
  //     return debouncedEvent(e);
  //   };
  // };

  return (
    <>
      <div id="validationFormikUrl">
        {label && (
          <Form.Label className={required ? "required" : ""}>
            {label ?? "URL"}
          </Form.Label>
        )}
        {text && <Form.Text>{text}</Form.Text>}
        <div
          className={
            "form-control" + (theValue && invalid ? " is-invalid" : "")
          }
          style={{ position: "relative", width: "unset" }}
        >
          <div>
            <input
              className="url-form-input"
              placeholder={placeholder ?? "Paste link here"}
              name={name}
              // onChange={debouncedChangeHandler}
              value={theValue}
              // onChange={debounceEvent(changeHandler, 1000)}
              onChange={changeHandler}
              onBlur={onBlur}
              onPaste={evt => {
                evt.preventDefault();
                evt.stopPropagation();
                var url = evt.clipboardData.getData("text");
                checkUrl(url);
              }}
            />
          </div>
          <div className="float-icon-right">
            {!invalid && theUrl && (
              <span
                style={{ cursor: "pointer" }}
                onClick={() => onClear()}
                className="material-icons"
              >
                delete
              </span>
            )}
          </div>
        </div>
        <Form.Control.Feedback type="invalid">
          Not a valid URL.
        </Form.Control.Feedback>
        {loadMetadata && (
          <>
            {loading && (
              <div style={{ marginTop: "1rem" }}>
                <LoadingAnimation size="sm" />
              </div>
            )}
            {theMetadata && theUrl && isUrl(theUrl) && showThumbnail && (
              <div style={{ marginTop: "1rem" }}>
                <MetadataThumbnail
                  image={true}
                  metadata={theMetadata}
                  url={theUrl}
                  clickable={false}
                  verticalLayout={false}
                />
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
};
export default UrlInput;
